import * as React from 'react';
import { GeneralDentalReferralSendButton } from './GeneralDentalReferralSendButton';
import { GeneralDentalReferralSaveButton } from './GeneralDentalReferralSaveButton';
import { GeneralDentalReferralApproveButton } from './GeneralDentalReferralApproveButton';
import { GeneralDentalReferralRejectButton } from './GeneralDentalReferralRejectButton';
import { GeneralDentalReferralRequestCompletionButton } from './GeneralDentalReferralRequestCompletionButton';
import { GeneralDentalReferralAnswerButton } from './GeneralDentalReferralAnswerButton';
import { GeneralDentalReferralMarkAnswerAsReadButton } from './GeneralDentalReferralMarkAnswerAsReadButton';
import { GeneralDentalReferralWithdrawButton } from './GeneralDentalReferralWithdrawButton';

interface IGeneralDentalReferralActionButtons {
    canEdit: boolean;
    canWithdraw: boolean;
    canReject: boolean;
    canRequestCompletion: boolean;
    canApprove: boolean;
    canWriteAnswer: boolean;
    hasUnreadAnswer: boolean;
    generalDentalReferralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number) => void;
}

export const GeneralDentalReferralActionButtons: React.FunctionComponent<IGeneralDentalReferralActionButtons> = ({ changeSuccessMessage, canEdit, canWithdraw, canReject, canRequestCompletion, canApprove, canWriteAnswer, hasUnreadAnswer, changeErrorMessage, getGeneralDentalReferral, generalDentalReferralId }) => {

    return (
        <>
            {
                canEdit || canWriteAnswer ?
                    <>
                        <GeneralDentalReferralSaveButton canWriteAnswer={canWriteAnswer} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId} />
                    </>
                    : null
            }
            {
                canEdit ?
                    <>
                        <GeneralDentalReferralSendButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId} />
                    </>
                    : null
            }
            {
                canWithdraw ?
                    <>
                        <GeneralDentalReferralWithdrawButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
            {
                canReject ?
                    <>
                        <GeneralDentalReferralRejectButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
            {
                canRequestCompletion ?
                    <>
                        <GeneralDentalReferralRequestCompletionButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
            {
                canApprove ?
                    <>
                        <GeneralDentalReferralApproveButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
            {
                canWriteAnswer ?
                    <>
                        <GeneralDentalReferralAnswerButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
            {
                hasUnreadAnswer ?
                    <>
                        <GeneralDentalReferralMarkAnswerAsReadButton changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getGeneralDentalReferral={getGeneralDentalReferral} generalDentalReferralId={generalDentalReferralId ?? 0} />
                    </>
                    : null
            }
        </>
    )
}